import React, { useEffect } from "react";
import { connect } from "react-redux";
import { DataTypes } from "../../../../constants";

import { Container, Grid } from "@mui/material";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import Fetching from "../../../Common/Fetching";
import NotificationCard from "./NotificationCard";
import rmsActions from "../../../../actions/rmsActions";
import {
    getNotifications,
    getRmsAppCode,
    isFetching,
} from "../../../../reducers";

function NotificationList({
    isFetching,
    notifications,
    getNotifications,
    appCode,
}) {
    useEffect(() => {
        getNotifications(appCode);
    }, [getNotifications, appCode]);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>
                {isFetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}
                {!!notifications &&
                    Array.isArray(notifications) &&
                    notifications
                        .sort((a, b) => (a.startedAt >= b.startedAt ? 1 : -1))
                        .map((notification) => (
                            <Grid item xs={12} key={notification.id}>
                                <NotificationCard notification={notification} />
                            </Grid>
                        ))}
            </Grid>
        </Container>
    );
}

const mapStateToProps = (state) => ({
    isFetching: isFetching(state, DataTypes.NOTIFICATIONS),
    notifications: getNotifications(state),
    appCode: getRmsAppCode(state),
});

export default connect(mapStateToProps, {
    getNotifications: rmsActions.getNotifications,
})(NotificationList);
